module.exports = __webpack_public_path__ + "img/city.a49fa226.png";